import React, { useState } from 'react';

const AdminAuthenticationContext = React.createContext(localStorage.getItem('accessToken') && true);

const AdminAuthenticationContextProvider = ({ children }) => {
    const changeAdminGlobalState = (value) => adminHasAuthenticated(value);

    const [isAuthenticated, adminHasAuthenticated] = useState(localStorage.getItem('accessToken') && true);

    return (
        <AdminAuthenticationContext.Provider value={{ isAuthenticated, changeAdminGlobalState }}>
            {children}
        </AdminAuthenticationContext.Provider>
    );
}

const AdminAuthenticationContextConsumer = AdminAuthenticationContext.Consumer;

export { AdminAuthenticationContextProvider, AdminAuthenticationContextConsumer, AdminAuthenticationContext };